import FlyDirect from "./FlyDirect.js";
import {climbCruise} from "../planeSlice.js";
import {getDistance} from "../../assets/virtual-flyout/nav-calc.js";
import {STANDARD_VS_CLIMB} from "../../assets/virtual-flyout/perf-calc.js";

export default class FlyDirectClimb extends FlyDirect {
    constructor(planeId, waypoint, altitude) {
        super(planeId, waypoint);
        this.altitude = altitude;
    }

    isComplete() {
        const planeState = this.getState();
        const altDiff = this.altitude - planeState.altitude;
        const timeToClimb = altDiff / STANDARD_VS_CLIMB * 60;
        const distanceToWp = getDistance(planeState.coordinates, this.waypoint);
        const timeToWp = distanceToWp / planeState.gs * 3600;
        if (timeToWp <= timeToClimb && planeState.vs <= 0) {
            this.log(`Climbing to ${this.altitude}ft`);
            this.dispatch(climbCruise({altitude: this.altitude}));
        }
        return super.isComplete();
    }
}